export function DeliverySlotBadge({ order, testId }) {
  const s = order?.delivery_slot;
  if (!s) return null;
  const fee = Number(order.delivery_fee || 0);
  const named = s.label && s.label !== s.range;
  return (
    <span className="inline-flex items-center gap-1 px-1 py-0 text-[9px] font-mono uppercase border border-[#00F0FF] text-[#00F0FF] whitespace-nowrap" data-testid={testId}>
      ⏰ {s.date?.slice(5).replace('-', '/')} {s.range}{named ? ` · ${s.label}` : ''} · {fee > 0 ? `$${fee.toFixed(2)}` : 'FREE'}{s.long_distance ? ' · LD' : ''}
    </span>
  );
}
